import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./index.css";
import {
  createBrowserRouter,
  Navigate,
  RouterProvider,
} from "react-router-dom";
import { ThemeProvider } from "@/themeConfigs/ThemeContext";
import { Provider } from "react-redux";
import store from "@/redux/store";
import ProtectedRoute from "@/routes/ProtectedRoute";
import GuestRoute from "@/routes/GuestRoute";
import Home from "./components/pages/supervisor/Dashboard/Home";
import Idle from "./components/pages/supervisor/Dashboard/Idle";
import InCharging from "./components/pages/supervisor/Dashboard/InCharging";
import FullyCharged from "./components/pages/supervisor/Dashboard/FullyCharged";
import CarsAllocated from "./components/pages/supervisor/Dashboard/CarAllocated";
import CheckOut from "./components/pages/supervisor/CheckOut";
import CheckOutCarAllocation from "./components/pages/supervisor/CheckOut/CheckoutCarAllocation";
import CheckIn from "./components/pages/supervisor/CheckIn";
import CheckInCarAllocation from "./components/pages/supervisor/CheckIn/CheckInCarAllocation";
import ChargerDetail from "./components/pages/Driver/Charge/ChargerDetail";
import ChargerScan from "./components/pages/Driver/Charge/ChargerScan";
import ChargerSelectList from "./components/pages/Driver/Charge/ChargerSelectList";
import ChargerSelectMap from "./components/pages/Driver/Charge/ChargerSelectMap";
import { ChargingHistory } from "./components/pages/Driver/Charge/ChargingHistory";
import { OngoingCharging } from "./components/pages/Driver/Charge/OngoingCharging";
import { CheckInViaDriverFlow } from "./components/pages/Driver/CheckInViaDriver";
import DriverHome from "./components/pages/Driver/Home";
import LoginFlow from "./components/pages/Driver/LoginFlow";
import Submit from "./components/pages/Driver/Submit";
import PayNow from "./components/pages/Driver/Submit/PayNow";
import Roster from "./components/pages/Driver/Roster";
import EverestTopup from "./components/pages/Driver/EverestTopup";
import DriverCheckInSuccess from "./components/pages/Driver/DriverCheckInSuccess";
import AppInitializer from "./components/AppInitializer";

const router = createBrowserRouter([
  {
    path: "/signin",
    element: (
      <GuestRoute>
        <App />
      </GuestRoute>
    ),
  },
  {
    path: "/home",
    element: (
      <ProtectedRoute>
        <Home />
      </ProtectedRoute>
    ),
  },
  {
    path: "/idle",
    element: (
      <ProtectedRoute>
        <Idle />
      </ProtectedRoute>
    ),
  },
  {
    path: "/in-charging",
    element: (
      <ProtectedRoute>
        <InCharging />
      </ProtectedRoute>
    ),
  },
  {
    path: "/fully-charged",
    element: (
      <ProtectedRoute>
        <FullyCharged />
      </ProtectedRoute>
    ),
  },
  {
    path: "/cars-allocated",
    element: (
      <ProtectedRoute>
        <CarsAllocated />
      </ProtectedRoute>
    ),
  },
  {
    path: "/check-out",
    element: (
      <ProtectedRoute>
        <CheckOut />
      </ProtectedRoute>
    ),
  },
  {
    path: "/check-out/car-allocation",
    element: (
      <ProtectedRoute>
        <CheckOutCarAllocation />
      </ProtectedRoute>
    ),
  },
  {
    path: "/check-in",
    element: (
      <ProtectedRoute>
        <CheckIn />
      </ProtectedRoute>
    ),
  },
  {
    path: "/check-in/car-allocation",
    element: (
      <ProtectedRoute>
        <CheckInCarAllocation />
      </ProtectedRoute>
    ),
  },
  {
    path: "/driver-home",
    element: (
      <ProtectedRoute>
        <DriverHome />
      </ProtectedRoute>
    ),
  },
  {
    path: "/driver-check-in-success",
    element: (
      <ProtectedRoute>
        <DriverCheckInSuccess />
      </ProtectedRoute>
    ),
  },
  {
    path: "/driver-login-flow",
    element: (
      <ProtectedRoute>
        <LoginFlow />
      </ProtectedRoute>
    ),
  },
  {
    path: "/driver-check-in",
    element: (
      <ProtectedRoute>
        <CheckInViaDriverFlow />
      </ProtectedRoute>
    ),
  },
  // {
  //   path: "/driver-submit",
  //   element: (
  //     <ProtectedRoute>
  //       <Submit />
  //     </ProtectedRoute>
  //   ),
  // },
  // {
  //   path: "/driver-submit/pay",
  //   element: (
  //     <ProtectedRoute>
  //       <PayNow />
  //     </ProtectedRoute>
  //   ),
  // },
  {
    path: "/driver-roster",
    element: (
      <ProtectedRoute>
        <Roster/>
      </ProtectedRoute>
    ),
  },
  {
    path: "/driver-topup",
    element: (
      <ProtectedRoute>
        <EverestTopup />
      </ProtectedRoute>
    ),
  },
  // {
  //   path: "/driver-charge",
  //   element: (
  //     <ProtectedRoute>
  //       <ChargerSelectMap />
  //     </ProtectedRoute>
  //   ),
  // },
  // {
  //   path: "/driver-charge/nearby",
  //   element: (
  //     <ProtectedRoute>
  //       <ChargerSelectList />
  //     </ProtectedRoute>
  //   ),
  // },
  // {
  //   path: "/driver-charge/:cId",
  //   element: (
  //     <ProtectedRoute>
  //       <ChargerDetail />
  //     </ProtectedRoute>
  //   ),
  // },
  // {
  //   path: "/driver-charge/:cId/scan",
  //   element: (
  //     <ProtectedRoute>
  //       <ChargerScan />
  //     </ProtectedRoute>
  //   ),
  // },
  // {
  //   path: "/driver-charge",
  //   element: (
  //     <ProtectedRoute>
  //       <ChargerDetail />
  //     </ProtectedRoute>
  //   ),
  // },
  // {
  //   path: "/driver-charge/ongoing",
  //   element: (
  //     <ProtectedRoute>
  //       <OngoingCharging />
  //     </ProtectedRoute>
  //   ),
  // },
  // {
  //   path: "/driver-charge/history",
  //   element: (
  //     <ProtectedRoute>
  //       <ChargingHistory />
  //     </ProtectedRoute>
  //   ),
  // },
  {
    path: "/",
    element: (
      <GuestRoute>
        <App />
      </GuestRoute>
    ),
  },
  {
    path: "*",
    element: <Navigate to="/home" replace />,
  },
]);

ReactDOM.createRoot(document.getElementById("root") as HTMLElement).render(
  <React.StrictMode>
    <Provider store={store}>
      <div className="font-poppins">
        <ThemeProvider>
          <AppInitializer>
            <RouterProvider router={router} />
          </AppInitializer>
        </ThemeProvider>
      </div>
    </Provider>
  </React.StrictMode>
);
